import React from "react"
import {Box, Paper, Typography} from "@mui/material";
import WalletIcon from "../layout/WalletIcon";
import "./Wallet.css"
import Wallet from "./Wallet";


const WalletGroup = ({walletGroup, onGroupClick, onWalletClick, type}) => {



    return <Paper elevation={10} sx={{borderRadius: "1rem", display: "inline-block"}} onClick={event => {onGroupClick(walletGroup); event.stopPropagation()}}
                  className={"walletGroup " + (walletGroup.balances && walletGroup.balances.length > 0 ? "full" : "")}>
        <Box sx={{width: "100%", height: 40, borderRadius: "1rem 1rem 0 0", position: "relative"}}>
            <Typography variant="h6"
                        sx={{fontWeight: 800, position: "absolute", opacity: "0.8", left: 15, top: 4, maxWidth: "80%"}}
                        noWrap={true}
            >{walletGroup.name}</Typography>
            <WalletIcon image={walletGroup.image} sx={{position: "absolute", right: 4, top: 2}}/>
        </Box>
        <Box sx={{width: "100%", borderRadius: "0 0 1rem 1rem", position: "relative", display: "block"}}>
            {(walletGroup.balances || [])
                .filter(wallet => wallet?.state !== "DELETED" && wallet?.active !== false && wallet?.active !== "false" && (type === 'ALL' || wallet.walletType === type))
                .map(
                    (wallet) =>
                        <Wallet key={wallet.id} walletBalance={wallet} onWalletClick={onWalletClick}/>
                )
            }
        </Box>
    </Paper>
}

export default WalletGroup